<template>
    <div class="app_update_notice_page">
        <div class="app_update_notice_container" v-if="isShowUpdateNotice">
            <div class="app_update_notice_title_box">
                <div class="img"></div>
                您的软件版本已经更新到{{ currentVersion() }}
            </div>
            <div class="app_update_notice_content">
                <p>更新内容：</p>
                <div v-if="updateContent != ''" v-html="updateContent"></div>
            </div>
            <div class="app_update_notice_btn button text_white_gradient_bg " @click="closeUpdateNotice">确定</div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { Brand, getBrand } from '@/brand/brand';
import i18n from '@/languages/i18n';
import { Http } from '@/network/http';
import { compare } from 'compare-versions';
import { ref, onMounted } from 'vue';
import { appVersion } from '../../service/env';
import { driverServiceVersion } from '@/upgrade/service';

const versionKey = "version_for_compare"
const defaultVersion = "0.0.0"
const updateContent = ref("");
const isShowUpdateNotice = ref(false);

const currentVersion = () => {
    const ver = appVersion();
    if (!ver) return defaultVersion;
    return ver
}

onMounted(async () => {
    if (i18n.global.locale != 'zh') {
        return
    }
    const date = "2024-11-23 00:00:00"
    if (Date.now() < new Date(date).getTime()) {
        if (getSavedVersion() == defaultVersion) {
            localStorage.setItem(versionKey, currentVersion())
            await showNotify(currentVersion())
        }
    }
    if (compare(currentVersion(), getSavedVersion(), '>')) {
        localStorage.setItem(versionKey, currentVersion())
        if (getSavedVersion() != defaultVersion) {
            await showNotify(currentVersion())
        }
    }
    checkServiceUpdate()
})

/*
* script升级后, 要判断service的版本是否匹配, 不匹配的话, 提示升级service
*/
const checkServiceUpdate = () => {
    if (isShowUpdateNotice.value == false) {
        driverServiceVersion.checkServiceVersion()
    }
}

const showNotify = async (current_version: string) => {
    const bd = await getBrand();
    const url = `/apps/driver_script/${current_version}`;
    const versions = await Http.get<AppInfo[]>(url, {}, baseUrl(bd));
    if (versions.length > 0 && versions[0].Version.UpdateInfo != "") {
        updateContent.value = versions[0].Version.UpdateInfo;
        isShowUpdateNotice.value = true;
    }
}

const baseUrl = (brand: Brand) => {
    if (brand == Brand.irok) {
        return "https://irok.ast.joyway.net"
    }
    if (brand == Brand.carotmas) {
        return "https://ncus.carotmas.com"
    }
    return "https://ncus.iyx.fun"
}

const getSavedVersion = (): string => {
    const version = localStorage.getItem(versionKey)
    if (version == null) {
        return defaultVersion
    }
    return version
}
const closeUpdateNotice = () => {
    isShowUpdateNotice.value = false
    checkServiceUpdate()
}
</script>


<script lang="ts">
interface AppInfo {
    ID: number;
    Name: string;
    StrID: string;
    Type: number;
    IsInternel: boolean;
    IsSilenceUpgrade: boolean;
    Version: Version;
}

interface Version {
    Valid: boolean;
    VersionName: string;
    DownloadURL: string;
    IsForced: boolean;
    IsDebug: boolean;
    Style: string;
    UpdateInfo: string;
    VersionRequied: string;
    Channel: string[];
}
</script>


<style scoped lang="less">
.app_update_notice_page {
    .app_update_notice_container {
        display: flex;
        flex-flow: column;
        align-items: center;

        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);

        width: 524px;
        min-height: 533px;
        background: #fff;
        box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.2);

        padding: 40px 50px;


        .app_update_notice_title_box {
            display: flex;
            align-items: center;
            justify-content: center;

            font-weight: bold;
            font-size: 22px;
            color: #ffb535;


            .img {
                width: 32px;
                height: 24px;
                margin-right: 10px;
                background-image: url('@/assets/img/upgrade.svg');
                background-size: 32px 32px;
            }
        }

        .app_update_notice_content {
            width: 100%;
            min-height: 322px;
            margin: 20px auto;
            background: #f6f6f6;
            font-size: 14px;
            line-height: 24px;
            color: #888;
            padding: 16px 20px;
        }

        .app_update_notice_btn {
            // background: @main_color;
            font-size: 16px;
            color: #fff;
            width: 112px;
            height: 42px;
            margin-top: 20px;
        }
    }
}
</style>
